import React from 'react';
import { formatMonto } from '../utils/format';

// `compacto` reduce el padding y la tipografía (usado en Movimientos, donde
// las tarjetas de resumen van apretadas junto a otras dos); sin el prop
// mantiene el tamaño original de Dashboard. `ancho` le da un mínimo de
// ancho para que no quede angosta al centrarla junto a las otras tarjetas.
export default function TarjetaIngresoEgreso({ titulo, ingresos, egresos, simbolo = '$', compacto = false, ancho = false }) {
  return (
    <div className={`bg-white rounded-xl shadow-sm ${compacto ? 'rounded-lg p-4' : 'p-5'} ${ancho ? 'min-w-[200px]' : ''}`}>
      <p className={`text-slate-500 ${compacto ? 'text-xs' : 'text-sm mb-2'}`}>{titulo}</p>
      <div className={`grid grid-cols-[auto_auto] items-baseline w-max ${compacto ? 'gap-x-1.5' : 'gap-x-2'}`}>
        <span className="text-xs font-medium text-slate-500">Ingresos</span>
        <p className={`font-bold text-green-600 text-right tabular-nums ${compacto ? 'text-sm' : 'text-lg'}`}>
          {simbolo}{formatMonto(ingresos)}
        </p>
        <span className="text-xs font-medium text-slate-500">Egresos</span>
        <p className={`font-bold text-red-600 text-right tabular-nums ${compacto ? 'text-sm' : 'text-lg'}`}>
          {simbolo}{formatMonto(egresos)}
        </p>
      </div>
    </div>
  );
}
